import accessibleTabsViewTemplate from "./AccessibleTabsViewTemplate";

/**
 *  @name app.common.directive.slider.accessibleTabs
 *  @date 12/13/2016
 *  @copyright 2015 Empower Retirement
 *  @description
 *  This directive uses the ui-router for tab content. If you are not using ui-router do not use this directive.
 *  Requires:
 *  tabs - array of tab objects. {id, uiSref, condition, text}
 *
 *  Optional:
 *  tab-navigation-id - navigation id
 *  tab-content-id - id for the content container
 *  @example
 *    <accessible-tabs
 *        tabs="[ { id: 'registrationWithoutPinTab',
 *                  uiSref: 'register.withoutPin',
 *                  text: ('tabs.noPin' | translate) },
 *                { id: 'registrationWithPinTab',
 *                  uiSref: 'register.withPin',
 *                  text: ( 'tabs.havePin' | translate )},
 *                { id: 'registrationWithGroupPasswordTab',
 *                  uiSref: 'register.withGroupPassword',
 *                  text: ( 'tabs.groupPassword' | translate ) } ]"
 *        tab-navigation-id="registrationTabs"
 *        tab-content-id="registrationContent">
 *    </accessible-tabs>
 *
 **/

const AccessibleTabs = angular
    .module("AccessibleTabs", [])
    .directive("accessibleTabs", ["$filter", "$timeout", accessibleTabsDirective]);

function accessibleTabsDirective($filter, $timeout) {
    return {
        restrict: "E",
        template: accessibleTabsViewTemplate,
        link: function (scope, element, attrs) {
            var tabs = scope.$eval(attrs.tabs),
                tabNavigationId = attrs.tabNavigationId,
                tabContentId = attrs.tabContentId;
            scope.tabs = tabs;
            scope.tabNavigationId = tabNavigationId || "tabNavigationId";
            scope.tabContentId = tabContentId || "tabContentId";

            scope.handleAccessibleTabClick = function () {
                $timeout(function () {
                    var content = angular.element(document.querySelector(".tab-pane.active"));
                    var contentInput = content.find("input:first");

                    if (contentInput.length) {
                        contentInput.focus();
                    } else {
                        var textEl = content.find("h1, h2, h3, p").first();
                        if (textEl.length) {
                            textEl.attr("tabindex", -1);
                            textEl.focus();
                        } else {
                            content.attr("tabindex", -1);
                            content.focus();
                        }
                    }
                }, 100);
            };
        }
    };
}

export default AccessibleTabs;
